import "../../../../css/RecruitmentScreen/RadioButton.css"; // Ensure CSS is imported
import "../../../../css/RecruitmentScreen/FormField.css"; // Ensure CSS is imported
import { useState, useEffect } from "react";
import {
  addSubmissionListener,
  getIsSubmitted,
} from "../Utils/submissionListener";
import Tooltip from "../../../DesignSystem/Tooltip/Tooltip";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/Circle Info - Small (filled).svg";

const RadioButtonGrid = ({
  options = [],
  tooltips = [],
  columns = 2,
  name,
  value,
  onChange,
  error,
}) => {
  const [isSubmitted, setIsSubmitted] = useState(getIsSubmitted());

  useEffect(() => {
    // Add a listener to track submission status updates
    const removeListener = addSubmissionListener(setIsSubmitted);
    setIsSubmitted(getIsSubmitted());
    // console.log("Is Submitted Form Field", isSubmitted);
    // console.log(isSubmitted === true ? false : readOnly);
    return () => removeListener(); // Clean up the listener on unmount
  }, [getIsSubmitted()]);

  const handleRadioChange = (event) => {
    if (isSubmitted) return;
    const selectedValue = event.target.value;
    onChange({ target: { name, value: selectedValue } });
  };

  return (
    <div
      className={`radio-grid ${error ? "error" : ""}`}
      style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
    >
      {options.map((option, index) => (
        <div key={index} className="radio-with-tooltip">
          <label className="radio-option">
            <input
              type="radio"
              name={name}
              value={option}
              onChange={handleRadioChange}
              checked={value === option}
            />
            <span className="custom-radio"></span>
            <div className="Content"> {option}</div>
          </label>

          {tooltips[index] && (
            <Tooltip content={tooltips[index]} position="top">
              <InfoIcon className="tooltip-icon" />
            </Tooltip>
          )}
        </div>
      ))}
      {/* {error && <span className="error-message">{error}</span>} */}
    </div>
  );
};

export default RadioButtonGrid;
